// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 764 ? "react-syntax-highlighter/lowlight-import" : chunkId) + "." + {"764":"e311bee1","787":"a6210f57"}[chunkId] + ".chunk.js";
};